import { Batch, RUN_TYPE } from './batch';
import { CoordinatorService } from './coordinator.service';
import { ScriptHitset } from './script-hitset';
import { FIRST_ARG } from './script-types';
import { XITEM_TYPE } from './x-item';

export class ScriptBatch {
    #coords: CoordinatorService;
    #batch: Batch;
    #hitset: ScriptHitset;
    #paramLs: string[] = [];

    constructor(coords: CoordinatorService, autouser: Batch) {
        this.#coords = coords;
        this.#batch = autouser;
        this.#hitset = new ScriptHitset(coords);
    }

    get id() {
        return this.#batch.id;
    }

   

    add(arg: XITEM_TYPE | XITEM_TYPE[] | FIRST_ARG) {
        this.#hitset.add(arg);
        return this;
    }

    addParam(x: string) {
        this.#paramLs.push(x);
    }

    run(tp: RUN_TYPE, params?: any) {
        this.#batch.run(tp, {
            itemLs: this.#hitset.mainXitemLs.map((x) => x.exportMemowl()),
            paramLs: this.#paramLs,
            params,
        });
    }

    test() {
        this.#batch.test();
    }

    log(prefix = 'BATCH') {
        console.log(`${prefix}:" HITSET: ${this.#hitset.size}`);

        return this;
    }
}
